import { Link } from "react-router-dom";
import { SITE, FOOTER_NAV } from "@/data/content";

export default function Footer() {
  const year = new Date().getFullYear();
  return (
    <footer className="border-t border-m61-line mt-12 bg-m61-surface">
      <div className="m61-container py-16 grid grid-cols-1 lg:grid-cols-12 gap-10">
        <div className="lg:col-span-5">
          <div className="flex items-center gap-3 mb-5">
            <img src="/meta61-icon.png" alt="Meta61" className="w-10 h-10 object-contain" width="40" height="40" />
            <span className="font-display text-lg font-semibold text-m61-text">{SITE.name}</span>
          </div>
          <p className="max-w-md text-m61-muted leading-relaxed mb-4">{SITE.positioningLine}</p>
          <p className="mt-2 text-sm">
            <a href={`mailto:${SITE.contactEmail}`} className="m61-link">{SITE.contactEmail}</a>
          </p>
        </div>

        <div className="lg:col-span-7 grid grid-cols-2 gap-8">
          {FOOTER_NAV.map((col) => (
            <div key={col.heading}>
              <h4 className="m61-label mb-4">{col.heading}</h4>
              <ul className="space-y-2.5 text-sm">
                {col.links.map((l) => (
                  <li key={l.to}>
                    <Link to={l.to} className="m61-link">{l.label}</Link>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>
      </div>

      {/* UN SDGs */}
      <div className="border-t border-m61-line">
        <div className="m61-container py-6 flex flex-col md:flex-row justify-between gap-4 text-xs text-m61-muted">
          <p>© {year} {SITE.name}. Australia.</p>
          <p className="font-mono tracking-widest">WHERE TECHNOLOGY AND GOVERNANCE CONVERGE</p>
        </div>
      </div>
    </footer>
  );
}
